import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import AssessmentForm from "./AssessmentForm";
import SubmissionAndResults from "./SubmissionAndResults";
import SingleAssessmentAuditTrail from "./SingleAssessmentAuditTrail";
import SubmissionAndResultForm from "./SubmissionAndResultForm";
import { GlobalIconNames } from "../../../../utils/GlobalIconNames";
import GradeMixSubmissionAndResults from "./GradeMixSubmissionAndResults";
import AssessmentMarking from "./AssessmentMarking";
import PermissionsGate from "../../../../utils/permissionGate";
import { usePreviousScreen } from "../../../../utils/commonFunction";
import { useNavigationHistory } from "../../../../utils/commonFunction";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const AssessmentTabs = ({ assName, lmType, gradingStandard, courseDetails }) => {
  const { id, subId, openTabs, subType, subSubId, attemptId } = useParams();
  const [prevScreenData, setPrevScreenData] = useState("");
  const searchParams = new URLSearchParams(window.location.search)
  const questionId = searchParams.get('questionId');
  const prevScreen = usePreviousScreen();
  const history = useHistory();

  const {getPreviousScreen , getTwoScreensBack} = useNavigationHistory();

  const prevScreenView = getPreviousScreen();
  getTwoScreensBack();

  const currentPath = useLocation();

  // Function to determine if Assessment Marking tab should be visible
  const shouldShowAssessmentMarkingTab = () => {
    // Always show if currently on assessment marking or its audit trail
    if (openTabs === "assessmentMarking" || openTabs === "assessmentMarkingAuditTrail") {
      return true;
    }
    
    // Show only if on SingleAssessmentAuditTrail AND came directly from assessment marking
    if (openTabs === "SingleAssessmentAuditTrail") {
      const assessmentMarkingPath = `/courseAdministration/coursesdetails/${id}/assessments/open/assigned/assessmentMarking/${subId}`;
      
      // Check if previous screen is exactly assessment marking (with or without query params)
      const cameFromAssessmentMarking = prevScreen === assessmentMarkingPath || prevScreen?.startsWith(assessmentMarkingPath + '?') || prevScreenData === assessmentMarkingPath;
      
      return currentPath?.pathname?.includes("submissionsAndResults") ? false : cameFromAssessmentMarking;
    }
    
    // Don't show for other tabs
    return false;
  };

  useEffect(() => {
    const getprevdata = sessionStorage.getItem("prevPath");

    if(getprevdata){
      setPrevScreenData(getprevdata);
    }
  }, [])

  return (
    <>
      <div className="tabs-wrap">
        <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
          <li className="nav-item" onClick={() => history.push(`/courseAdministration/coursesdetails/${id}/assessments/open/assigned/Details/${subId}`)}>
            <a className={`nav-link cursor-pointer ${openTabs === "Details" ? "active" : ""}`} id="pills-tab1" data-toggle="pill" role="tab" aria-controls="pills-tab11" aria-selected="true">
              {GlobalIconNames("details").html}
            </a>
          </li>
          
          <PermissionsGate scopes={["casubmissionresultview"]} >
            <li className="nav-item" onClick={() => history.push(`/courseAdministration/coursesdetails/${id}/assessments/open/assigned/submissionsAndResults/${subId}`)}>
              <a
                className={`nav-link cursor-pointer ${openTabs === "submissionsAndResults" ? "active" : ""}`}
                id="pills-tab2"
                data-toggle="pill"
                role="tab"
                aria-controls="pills-tab12"
                aria-selected="true"
              >
                <i className="fal fa-books"></i>Submissions and Results
              </a>
            </li>
            
            {/* Fixed Assessment Marking tab visibility logic */}
            {shouldShowAssessmentMarkingTab() && 
              <li className="nav-item"
                onClick={() => history.push(questionId ? 
                  `/courseAdministration/coursesdetails/${id}/assessments/open/assigned/assessmentMarking/${subId}?questionId=${questionId}` : 
                  `/courseAdministration/coursesdetails/${id}/assessments/open/assigned/assessmentMarking/${subId}`
                )}
              >
                <a
                  className={`nav-link cursor-pointer ${openTabs === "assessmentMarking" ? "active" : ""}`}
                  id="pills-tab-marking"
                  data-toggle="pill"
                  role="tab"
                  aria-controls="pills-tab-marking"
                  aria-selected="true"
                >
                  <i className="fal fa-clipboard-check"></i>Assessment Marking
                </a>
              </li>
            }
          </PermissionsGate>
          
          <li className="nav-item" onClick={() => history.push(questionId ? `/courseAdministration/coursesdetails/${id}/assessments/open/assigned/assessmentMarkingAuditTrail/${subId}?questionId=${questionId}` : (openTabs == "submissionsAndResults" && subType == "update" && attemptId) ? `/courseAdministration/coursesdetails/${id}/assessments/open/assigned/studentFeedbackMultiAttemptAuditTrail/${subId}/update/${subSubId}/attempts/open/${attemptId}` : (openTabs == "submissionsAndResults" && subType == "update") ? `/courseAdministration/coursesdetails/${id}/assessments/open/assigned/studentFeedbackAuditTrail/${subId}/update/${subSubId}` : `/courseAdministration/coursesdetails/${id}/assessments/open/assigned/SingleAssessmentAuditTrail/${subId}`)}>
            <a
              className={`nav-link cursor-pointer ${openTabs === "SingleAssessmentAuditTrail" || (openTabs === "assessmentMarkingAuditTrail" && questionId) || (openTabs == "studentFeedbackAuditTrail") || (openTabs == "studentFeedbackMultiAttemptAuditTrail" && attemptId) ? "active" : ""}`}
              id="pills-tab3"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-tab13"
              aria-selected="true"
            >
              {GlobalIconNames("audittrail").html}
            </a>
          </li>
        </ul>

        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade active show" id="pills-tab11" role="tabpanel" aria-labelledby="pills-tab1">
            {openTabs == "Details" && <AssessmentForm lmType={lmType} gradingStandard={gradingStandard} />}
          </div>
          <div className="tab-pane fade active show" id="pills-tab12" role="tabpanel" aria-labelledby="pills-tab2">
            {openTabs == "submissionsAndResults" ? subType == "update" ? <SubmissionAndResultForm courseDetails={courseDetails} assName={assName}/> : gradingStandard == 2 ? <GradeMixSubmissionAndResults courseDetails={courseDetails} assName={assName}/> : <SubmissionAndResults assName={assName} courseDetails={courseDetails}/> : ""}
          </div>
          <div className="tab-pane fade active show" id="pills-tab13" role="tabpanel" aria-labelledby="pills-tab3">
            {openTabs == "SingleAssessmentAuditTrail" ? <SingleAssessmentAuditTrail /> : openTabs == "assessmentMarkingAuditTrail" ? <SingleAssessmentAuditTrail questionId={questionId} assScreen={"assessmentMarkingAuditTrail"} /> : openTabs == "studentFeedbackAuditTrail" ? <SingleAssessmentAuditTrail questionId={subSubId} assScreen={"studentFeedbackAuditTrail"} /> : (openTabs == "studentFeedbackMultiAttemptAuditTrail" && attemptId) ? <SingleAssessmentAuditTrail questionId={subSubId} assScreen={"studentFeedbackMultiAttemptAuditTrail"} attemptId={attemptId} /> : ""}
          </div>
          <div className="tab-pane fade active show" id="pills-tab12" role="tabpanel" aria-labelledby="pills-tab2">
            {openTabs == "assessmentMarking" ? <AssessmentMarking courseDetails={courseDetails}/> : ""}
          </div>
        </div>
      </div>
    </>
  );
};

export default AssessmentTabs;